export const extractFileNameFromUrl = (url: string): string =>
  new URL(url).pathname.split("/").pop()!;
